export const ymdUTC = (ms) => new Date(ms).toISOString().slice(0, 10);